import { EnvironmentUrls } from 'Roblox';
import { deviceMeta as DeviceMeta, jsClientDeviceIdentifier } from 'header-scripts';
import { playGameService } from 'core-roblox-utilities';
import playButtonConstants from '../constants/playButtonConstants';

export const launchGame = (placeId: number): void => {
  const deviceMeta = DeviceMeta.getDeviceMeta();
  if (deviceMeta?.isIosDevice || jsClientDeviceIdentifier.isIos13Ipad) {
    window.open(
      `https://assetgame.${EnvironmentUrls.domain}/games/start?placeid=${placeId}`,
      '_blank'
    );
  } else if (deviceMeta?.isAndroidDevice) {
    window.open(
      `intent://placeID=${placeId}#Intent;scheme=robloxmobile;package=com.roblox.client;S.browser_fallback_url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.roblox.client;end`
    );
  } else {
    playGameService.launchGame(
      playGameService.buildPlayGameProperties(undefined, placeId.toString()),
      playButtonConstants.eventStreamProperties(placeId)
    );
  }
};

export const launchLogin = (placeId: number): void => {
  const deviceMeta = DeviceMeta.getDeviceMeta();
  if (
    deviceMeta?.isIosDevice ||
    deviceMeta?.isAndroidDevice ||
    jsClientDeviceIdentifier.isIos13Ipad
  ) {
    window.location.assign(`/login`);
  } else {
    playGameService.launchGame(
      playGameService.buildPlayGameProperties(undefined, placeId.toString()),
      playButtonConstants.eventStreamProperties(placeId)
    );
  }
};
